<template>
    <div>
        <b-overlay :show="loading" no-wrap rounded></b-overlay>
        <b-table small stacked="sm" striped hover  :fields="modelColumns" :items="items" :show-empty="true"  :empty-text="'No se ha realizado ningun pago a esta reservación'">
            <template #cell(total)="row">
              {{$root.formatLblPrice(row.item.total,payment.currency)}}
            </template>
            <template #cell(engineTotal)="row">
              {{$root.formatLblPrice(row.item.engineTotal,row.item.engineCurrency)}}
            </template>
        </b-table>
    </div>
</template>

<script>
    export default {
        props: {
            payment: {
                type : Object,
                required: true,
            }
        },
        data(){
            return {
                data:[],
                loading:false,
                modelColumns : [
                    {key:'reference',label:'Referencia de pago'},
                    {key:'cardholder',label:'Titular de la tarjeta'},
                    {key:'cardType',label:'Tipo tarjeta'},
                    {key:'last4',label:'last 4'},
                    {key:'engineTotal',label:'Total Engine',class:'text-right'},
                    {key:'total',label:'Total',class:'text-right'},
                    {key:'creationDatetime',label:'Fecha'},
                    {key:'status',label:'Status'},
                ],
            }
        },
        methods:{
          
        },
        mounted:function(){
           
        },
        computed:{
            items(){
                return this.payment.transactions??[]
            }
         
        },




    }
</script>
